import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/karl/github.com/limbario/limbar/limbar-io/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/karl/github.com/limbario/limbar/limbar-io/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/Users/karl/github.com/limbario/limbar/limbar-io/public/logo-gradient.svg");
